import React from "react";

export const Notification = () => {
  const [Read, setRead] = React.useState(true);

  const [UnRead, setUnRead] = React.useState(false);

  const ReadNoti = (e) => {
    setRead(true);
    setUnRead(false);
  };
  const UnReadNoti = (e) => {
    setRead(false);
    setUnRead(true);
  };

  return (
    <>
      No current notifications
      {/* <div >
                <div id="imagesWrapper" className="innerWrapperPanel" >
                    <div className="templatesWrapper">

                        <div className="tabs mb-3">
                            <div className={"tabButton" + (Read ? " activeTab" : "")} onClick={ReadNoti}>
                                Unread
                            </div>
                            <div className={"tabButton" + (UnRead ? " activeTab" : "")} onClick={UnReadNoti}>
                                Read
                            </div>
                        </div>

                    </div>
                </div>
                {Read &&
                    <div>
                        <div className="card w-50 mt-2 notiShadow"  >
                            <div className="card-body">
                                <img style={{ height: "88px" }} className="rounded mr-xl-3 mb-3 mb-xl-0" src={"images/notificationDemoPic.jpg"} alt="" />

                                <h5 className="card-title text-primary" style={{ display: "inline-block" }}>Card title</h5>
                                <p className="card-text" style={{ marginTop: "10px" }}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <span className="card-link">
                                    <div className="CTAButton" style={{ width: "160px" }}>
                                        <div className="CTAButtonText">
                                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>mark_email_read</span>
                                            <div className="CTAButton_style" style={{ marginLeft: "7px" }}>Mark Read</div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="card w-50 mt-2 notiShadow"  >
                            <div className="card-body">
                                <img style={{ height: "88px" }} className="rounded mr-xl-3 mb-3 mb-xl-0" src={"images/notificationDemoPic.jpg"} alt="" />

                                <h5 className="card-title text-primary" style={{ display: "inline-block" }}>Card title</h5>
                                <p className="card-text" style={{ marginTop: "10px" }}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <span className="card-link">
                                    <div className="CTAButton" style={{ width: "160px" }}>
                                        <div className="CTAButtonText">
                                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>mark_email_read</span>
                                            <div className="CTAButton_style" style={{ marginLeft: "7px" }}>Mark Read</div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="card w-50 mt-2 notiShadow"  >
                            <div className="card-body">
                                <img style={{ height: "88px" }} className="rounded mr-xl-3 mb-3 mb-xl-0" src={"images/notificationDemoPic.jpg"} alt="" />

                                <h5 className="card-title text-primary" style={{ display: "inline-block" }}>Card title</h5>
                                <p className="card-text" style={{ marginTop: "10px" }}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <span className="card-link">
                                    <div className="CTAButton" style={{ width: "160px" }}>
                                        <div className="CTAButtonText">
                                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>mark_email_read</span>
                                            <div className="CTAButton_style" style={{ marginLeft: "7px" }}>Mark Read</div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="card w-50 mt-2 notiShadow"  >
                            <div className="card-body">
                                <img style={{ height: "88px" }} className="rounded mr-xl-3 mb-3 mb-xl-0" src={"images/notificationDemoPic.jpg"} alt="" />

                                <h5 className="card-title text-primary" style={{ display: "inline-block" }}>Card title</h5>
                                <p className="card-text" style={{ marginTop: "10px" }}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <span className="card-link">
                                    <div className="CTAButton" style={{ width: "160px" }}>
                                        <div className="CTAButtonText">
                                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>mark_email_read</span>
                                            <div className="CTAButton_style" style={{ marginLeft: "7px" }}>Mark Read</div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                }
                {!Read &&
                    <div>
                        <div className="card w-50 mt-2 notiShadow"  >
                            <div className="card-body">
                                <img style={{ height: "88px" }} className="rounded mr-xl-3 mb-3 mb-xl-0" src={"images/notificationDemoPic.jpg"} alt="" />

                                <h5 className="card-title text-primary" style={{ display: "inline-block" }}>Card title</h5>
                                <p className="card-text" style={{ marginTop: "10px" }}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <span className="card-link">
                                    <div className="CTAButton" style={{ width: "180px" }}>
                                        <div className="CTAButtonText">
                                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>markunread</span>
                                            <div className="CTAButton_style" style={{ marginLeft: "7px" }}>Mark Unread</div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="card w-50 mt-2 notiShadow"  >
                            <div className="card-body">
                                <img style={{ height: "88px" }} className="rounded mr-xl-3 mb-3 mb-xl-0" src={"images/notificationDemoPic.jpg"} alt="" />

                                <h5 className="card-title text-primary" style={{ display: "inline-block" }}>Card title</h5>
                                <p className="card-text" style={{ marginTop: "10px" }}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <span className="card-link">
                                    <div className="CTAButton" style={{ width: "180px" }}>
                                        <div className="CTAButtonText">
                                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>markunread</span>
                                            <div className="CTAButton_style" style={{ marginLeft: "7px" }}>Mark Unread</div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>

                        <div className="card w-50 mt-2 notiShadow"  >
                            <div className="card-body">
                                <img style={{ height: "88px" }} className="rounded mr-xl-3 mb-3 mb-xl-0" src={"images/notificationDemoPic.jpg"} alt="" />

                                <h5 className="card-title text-primary" style={{ display: "inline-block" }}>Card title</h5>
                                <p className="card-text" style={{ marginTop: "10px" }}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <span className="card-link">
                                    <div className="CTAButton" style={{ width: "180px" }}>
                                        <div className="CTAButtonText">
                                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>markunread</span>
                                            <div className="CTAButton_style" style={{ marginLeft: "7px" }}>Mark Unread</div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>

                        <div className="card w-50 mt-2 notiShadow"  >
                            <div className="card-body">
                                <img style={{ height: "88px" }} className="rounded mr-xl-3 mb-3 mb-xl-0" src={"images/notificationDemoPic.jpg"} alt="" />

                                <h5 className="card-title text-primary" style={{ display: "inline-block" }}>Card title</h5>
                                <p className="card-text" style={{ marginTop: "10px" }}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <span className="card-link">
                                    <div className="CTAButton" style={{ width: "180px" }}>
                                        <div className="CTAButtonText">
                                            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>markunread</span>
                                            <div className="CTAButton_style" style={{ marginLeft: "7px" }}>Mark Unread</div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>

                    </div>
                }
            </div> */}
    </>
  );
};

export default Notification;
